import * as React from "react";
import { ShopCardLarge } from "@components/ShopCardListItem/ShopCardLarge";
import styles from "./index.module.css";
import type { Shops_UsersPayloadsSearchShopsResultItemFragment } from "@pages/shops/__generated__/fragments";

type ShopListProps = {
  items: Shops_UsersPayloadsSearchShopsResultItemFragment[];
};

export const ShopCardList: React.FC<ShopListProps> = ({ items }) => {
  if (items.length === 0) {
    return (
      <div className={styles.notfound}>
        <p className={styles.notfoundTitle}>
          指定した条件では見つかりませんでした
        </p>
        <p className={styles.notfoundText}>
          条件を変更して再度検索してください
        </p>
      </div>
    );
  }

  return (
    <div className={styles.list}>
      {items.map((item) => (
        <ShopCardLarge
          key={item.shop.uuid}
          shop={item.shop}
          shopMatch={item.latestShopMatch ?? undefined} // latestShopMatchがnullの場合、型エラーになるためundefinedを明示的に指定
          headingTag
        />
      ))}
    </div>
  );
};
